import React from "react";
import Typography from "Components/Atoms/Typography";
import AuthNavBar from "App/Auth/Components/AuthNavBar";
import "./styles.scss";

export type AuthLayoutProps = {
  title: string;
  subtitle?: React.ReactNode;
  // Status shown above the form, e.g. why the last sign-in did not work.
  status?: React.ReactNode;
  children: React.ReactNode;
  headingRef?: React.Ref<HTMLHeadingElement>;
};

// Shared frame of the sign-in screens: content width, spacing and a status area.
// The content flows and scrolls normally, so a short viewport or an open
// on-screen keyboard never hides the primary action.
const AuthLayout = ({
  title,
  subtitle,
  status,
  children,
  headingRef,
}: AuthLayoutProps) => (
  <div className="auth-layout">
    <AuthNavBar />
    <div className="auth-layout-body">
      <main className="auth-layout-content">
        <div className="auth-layout-column">
          <h1 className="auth-layout-title" ref={headingRef} tabIndex={-1}>
            <Typography variant="h3" component="span" block translation="auth">
              {title}
            </Typography>
          </h1>
          {subtitle && (
            <Typography
              variant="text-3"
              color="subdued"
              component="p"
              className="auth-layout-subtitle"
              translation="auth"
            >
              {subtitle}
            </Typography>
          )}
          {status}
          {children}
        </div>
      </main>
      <div
        className="auth-layout-image"
        style={{ backgroundImage: 'url("/dishwasher.jpg")' }}
        aria-hidden
      />
    </div>
  </div>
);

export default AuthLayout;
